import { usePermissionContext } from "@/shared/hooks/usePermissionContext";
import { PermissionAction, PermissionResource } from "@/entities/user";

export const useRoutePermission = () => {
  const {
    hasPermission,
    isSuperAdmin,
    userRole,
    profileData
  } = usePermissionContext();

  const canAccessRoute = (
    resource: PermissionResource,
    action: PermissionAction = 'read'
  ): boolean => hasPermission(resource, action);

  const canAccessRouteWithAnyPermission = (
    permissions: Array<{ resource: PermissionResource; action: PermissionAction }>
  ): boolean =>
    permissions.some(({ resource, action }) => hasPermission(resource, action));

  const canAccessRouteWithAllPermissions = (
    permissions: Array<{ resource: PermissionResource; action: PermissionAction }>
  ): boolean =>
    permissions.every(({ resource, action }) => hasPermission(resource, action));

  const canAccessRouteByRole = (allowedRoles: string[]): boolean => {
    if (isSuperAdmin) return true;
    return userRole ? allowedRoles.includes(userRole) : false;
  };

  const isAuthenticated = (): boolean => {
    if (profileData?.user?.isSuperAdmin) return true;
    return !!profileData && !!profileData.user && !!profileData.store;
  };

  const hasActiveStore = (): boolean =>
    profileData?.store?.status === 'ACTIVE';

  return {
    canAccessRoute,
    canAccessRouteWithAnyPermission,
    canAccessRouteWithAllPermissions,
    canAccessRouteByRole,
    isAuthenticated,
    hasActiveStore,
    isSuperAdmin,
    userRole,
  };
};

export default useRoutePermission;
